/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePrescriptionRequestDto,
  ErrorResponse,
  GetPrescriptionFiltersResponseDto,
  GetPrescriptionsResponseDto,
  PrescriptionDto,
} from '../models/index';
import {
    CreatePrescriptionRequestDtoFromJSON,
    CreatePrescriptionRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPrescriptionFiltersResponseDtoFromJSON,
    GetPrescriptionFiltersResponseDtoToJSON,
    GetPrescriptionsResponseDtoFromJSON,
    GetPrescriptionsResponseDtoToJSON,
    PrescriptionDtoFromJSON,
    PrescriptionDtoToJSON,
} from '../models/index';

export interface AdminGetPrescriptionByIdRequest {
    prescriptionId: string;
}

export interface GetPrescriptionsForAdminRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForAdminSortByEnum;
    orderBy?: string;
    practiceIds?: string;
    practiceName?: string;
    patientId?: string;
    search?: string;
    practiceId?: string;
}

export interface GetPrescriptionsForPatientRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForPatientSortByEnum;
    orderBy?: string;
    providerIds?: string;
    search?: string;
    fromDate?: Date;
    toDate?: Date;
    fromPrice?: number;
    toPrice?: number;
}

export interface GetPrescriptionsForProviderRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForProviderSortByEnum;
    orderBy?: string;
    patientId?: string;
    search?: string;
}

export interface PatientCancelPrescriptionRequest {
    prescriptionId: string;
}

export interface PatientGetPrescriptionByIdRequest {
    prescriptionId: string;
}

export interface ProviderCancelPrescriptionRequest {
    prescriptionId: string;
}

export interface ProviderCreatePrescriptionRequest {
    createPrescriptionRequestDto: CreatePrescriptionRequestDto;
}

export interface ProviderGetPrescriptionByIdRequest {
    prescriptionId: string;
}

/**
 * 
 */
export class PrescriptionApi extends runtime.BaseAPI {

    /**
     * Admin can access any prescription by ID without permission checks
     * Get prescription by ID for admin
     */
    async adminGetPrescriptionByIdRaw(requestParameters: AdminGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling adminGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Admin can access any prescription by ID without permission checks
     * Get prescription by ID for admin
     */
    async adminGetPrescriptionById(requestParameters: AdminGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.adminGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin-scoped list of prescriptions across all practices with search, sort, filter, and pagination. Includes practice information.
     * Get prescriptions for admin
     */
    async getPrescriptionsForAdminRaw(requestParameters: GetPrescriptionsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['practiceIds'] != null) {
            queryParameters['practiceIds'] = requestParameters['practiceIds'];
        }

        if (requestParameters['practiceName'] != null) {
            queryParameters['practiceName'] = requestParameters['practiceName'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patientId'] = requestParameters['patientId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['practiceId'] != null) {
            queryParameters['practiceId'] = requestParameters['practiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Admin-scoped list of prescriptions across all practices with search, sort, filter, and pagination. Includes practice information.
     * Get prescriptions for admin
     */
    async getPrescriptionsForAdmin(requestParameters: GetPrescriptionsForAdminRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescriptions for a patient
     * Get prescriptions for patient
     */
    async getPrescriptionsForPatientRaw(requestParameters: GetPrescriptionsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['providerIds'] != null) {
            queryParameters['providerIds'] = requestParameters['providerIds'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = requestParameters['fromDate'];
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = requestParameters['toDate'];
        }

        if (requestParameters['fromPrice'] != null) {
            queryParameters['fromPrice'] = requestParameters['fromPrice'];
        }

        if (requestParameters['toPrice'] != null) {
            queryParameters['toPrice'] = requestParameters['toPrice'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescriptions for a patient
     * Get prescriptions for patient
     */
    async getPrescriptionsForPatient(requestParameters: GetPrescriptionsForPatientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescriptions for provider
     */
    async getPrescriptionsForProviderRaw(requestParameters: GetPrescriptionsForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patientId'] = requestParameters['patientId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescriptions for provider
     */
    async getPrescriptionsForProvider(requestParameters: GetPrescriptionsForProviderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancels a prescription for a patient
     * Cancel prescription for patient
     */
    async patientCancelPrescriptionRaw(requestParameters: PatientCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling patientCancelPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/{prescriptionId}/cancel`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a prescription for a patient
     * Cancel prescription for patient
     */
    async patientCancelPrescription(requestParameters: PatientCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patientCancelPrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Get prescription by ID for patient
     */
    async patientGetPrescriptionByIdRaw(requestParameters: PatientGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling patientGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription by ID for patient
     */
    async patientGetPrescriptionById(requestParameters: PatientGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.patientGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription filters for patient
     */
    async patientGetPrescriptionFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionFiltersResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionFiltersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription filters for patient
     */
    async patientGetPrescriptionFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionFiltersResponseDto> {
        const response = await this.patientGetPrescriptionFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Cancels a prescription for a provider
     * Cancel prescription for provider
     */
    async providerCancelPrescriptionRaw(requestParameters: ProviderCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling providerCancelPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/{prescriptionId}/cancel`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a prescription for a provider
     * Cancel prescription for provider
     */
    async providerCancelPrescription(requestParameters: ProviderCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.providerCancelPrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a prescription for a provider
     * Create prescription for provider
     */
    async providerCreatePrescriptionRaw(requestParameters: ProviderCreatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createPrescriptionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPrescriptionRequestDto',
                'Required parameter "createPrescriptionRequestDto" was null or undefined when calling providerCreatePrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrescriptionRequestDtoToJSON(requestParameters['createPrescriptionRequestDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates a prescription for a provider
     * Create prescription for provider
     */
    async providerCreatePrescription(requestParameters: ProviderCreatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.providerCreatePrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription by ID for provider
     */
    async providerGetPrescriptionByIdRaw(requestParameters: ProviderGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling providerGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription by ID for provider
     */
    async providerGetPrescriptionById(requestParameters: ProviderGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.providerGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPrescriptionsForAdminSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForAdminSortByEnum = typeof GetPrescriptionsForAdminSortByEnum[keyof typeof GetPrescriptionsForAdminSortByEnum];
/**
 * @export
 */
export const GetPrescriptionsForPatientSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForPatientSortByEnum = typeof GetPrescriptionsForPatientSortByEnum[keyof typeof GetPrescriptionsForPatientSortByEnum];
/**
 * @export
 */
export const GetPrescriptionsForProviderSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForProviderSortByEnum = typeof GetPrescriptionsForProviderSortByEnum[keyof typeof GetPrescriptionsForProviderSortByEnum];
